import { Pipe, PipeTransform } from '@angular/core';
import { TravellerXGender, TravellerXTitle } from "libraries/service/resources/booking/interfaces/get-bookings.enum";

@Pipe({
  name: 'titleToGender'
})
export class TitleToGenderPipe implements PipeTransform {

  public transform(title: TravellerXTitle|string): TravellerXGender {
    if (!title) {
      return null;
    }

    if (title.toLowerCase() === TravellerXTitle.mr) {
      return TravellerXGender.male;
    }

    if (title.toLowerCase() === TravellerXTitle.ms || title.toLowerCase() === 'mrs') {
      return TravellerXGender.female;
    }

    return null;
  }

}
